import { useState } from 'react';
import { endpoints } from '@/api/endpoints';
import { useApi } from '@/api/useApi';
import { DataTable, type Column } from '@/components/DataTable';
import { StatusBadge } from '@/components/StatusBadge';
import { useLanguage } from '@/i18n/LanguageContext';
import { formatDateTime, formatNumber } from '@/i18n/format';
import type { ReturnRow } from '@/api/types';

const LIMIT = 50;

export function ReturnsListPage(): JSX.Element {
  const [offset, setOffset] = useState(0);
  const result = useApi(() => endpoints.returns({ limit: LIMIT, offset }), [offset]);
  const { t, locale } = useLanguage();

  const columns: readonly Column<ReturnRow>[] = [
    { key: 'number', header: t('returnsPage.colReturn'), render: (r) => r.number },
    { key: 'state', header: t('common.status'), render: (r) => <StatusBadge value={r.state} /> },
    { key: 'lines', header: t('returnsPage.colLines'), align: 'right', render: (r) => formatNumber(r.line_count, locale) },
    { key: 'discrepancies', header: t('returnsPage.colDiscrepancies'), align: 'right', render: (r) => formatNumber(r.discrepancy_count, locale) },
    { key: 'arrived', header: t('returnsPage.colArrived'), render: (r) => (r.arrived_at ? formatDateTime(r.arrived_at, locale) : '—') },
  ];

  return (
    <div>
      <div className="page-header">
        <h1>{t('nav.returns')}</h1>
      </div>
      <DataTable
        result={result}
        columns={columns}
        getRowHref={(r) => `/returns/${r.id}`}
        limit={LIMIT}
        offset={offset}
        onPageChange={setOffset}
        emptyTitle={t('returnsPage.emptyTitle')}
      />
    </div>
  );
}
